'use client';

import { useFormContext } from '@ariakit/react';
import cx from 'classnames';

import { FormInput } from '~/ui/components/form/input';
import typographyStyles from '~/ui/styles/typography.module.scss';
import { invariant } from '~/utils/invariant';

import styles from './formRange.module.scss';

export interface FormRangeProps {
  className?: string;
  name: { min: string; max: string };
  label?: string;
  inputLabels?: { min: string; max: string };
  validations?: {
    minRegex?: string;
    maxRegex?: string;
    error?: string;
  };
}

export function FormRange({
  className,
  name,
  label,
  inputLabels,
  validations,
  ...props
}: FormRangeProps): React.ReactElement {
  const form = useFormContext();
  invariant(form, 'FormRange must be wrapped in FormProvider');

  return (
    <div className={cx(className, typographyStyles.bodySmall)} {...props}>
      {label && <div>{label}</div>}

      <div className={styles.range}>
        <FormInput
          fieldName={name.min}
          inputLabel={inputLabels?.min || ''}
          validationRegex={validations?.minRegex}
          validationError={validations?.error}
          disableSubmit
        />

        <span className={styles.divider}>to</span>

        <FormInput
          fieldName={name.max}
          inputLabel={inputLabels?.max || ''}
          validationRegex={validations?.maxRegex}
          validationError={validations?.error}
          disableSubmit
        />
      </div>
    </div>
  );
}
